import { useMutation } from 'react-query';
import { api } from '../../services/api';
import Button from '../ui/Button';
import { errorMessage } from '../../lib/programs';
import { FilePayload, downloadFile } from './logistics';

/** Canva Bulk Create data: Name, Pronouns, Designation, Title, Organization, Role; in person only. Admins only:
 *  it lists people. Drawn in the Nametags row of "For the hotel, the caterer and the door" (AgendaOutputs.tsx). */
export function NametagCsvLink({ eventId, canEdit }: { eventId: string; canEdit: boolean }) {
  const get = useMutation(
    async () => (await api.post(`/events/${eventId}/nametags.csv`)).data.data as FilePayload & { rows: number },
    { onSuccess: downloadFile },
  );
  if (!canEdit) return null;
  return (
    <>
      <Button size="sm" variant="quiet" disabled={get.isLoading} onClick={() => get.mutate()}>
        For Canva (.csv)
      </Button>
      {get.error ? (
        <span className="block text-small text-warning mt-1 whitespace-normal">
          {errorMessage(get.error, 'Could not prepare the file.')}
        </span>
      ) : null}
    </>
  );
}
